import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { serverBaseWebSocketUrl } from '../../general-utilities/urlUtils';
import { commandStore } from '../../stores/CommandStore';

interface CommandControllerProps {
  orgId: number;
  campaignId: string;
  droneUuid: string;
}

export const CommandController = ({ orgId, campaignId, droneUuid }: CommandControllerProps) => {
  const { t } = useTranslation();

  const connect = useCallback((): void => {
    if (commandStore.socket || !orgId || !campaignId || !droneUuid) {
      return;
    }

    const wsConnectionStr = `${serverBaseWebSocketUrl}/ws/org/${orgId}/campaign/${campaignId}/drone/${droneUuid}/command/`;

    console.log(
      wsConnectionStr,
      'len=',
      wsConnectionStr.length,
      Array.from(wsConnectionStr).map((c) => c.charCodeAt(0))
    );

    const trimmedConnectionStr = wsConnectionStr.trim();

    console.log(
      trimmedConnectionStr,
      'len=',
      trimmedConnectionStr.length,
      Array.from(trimmedConnectionStr).map((c) => c.charCodeAt(0))
    );

    console.log('Connecting to Command WS:', wsConnectionStr);
    const socketNew = new WebSocket(wsConnectionStr);
    commandStore.setSocket(socketNew);

    socketNew.onopen = () => {
      console.log('Command WebSocket connected');
    };

    socketNew.onmessage = (event: MessageEvent) => {
      const ack = JSON.parse(event.data);
      if (ack.type === 'error') {
        toast.error(t('general_errors.command_error'));
      }
    };

    socketNew.onclose = () => {
      commandStore.setSocket(null);
    };

    socketNew.onerror = () => {
      toast.error(t('general_errors.connection_error'));
      socketNew.close();
    };
  }, [orgId, campaignId, droneUuid, t]);

  const disconnect = useCallback((): void => {
    if (commandStore.socket) {
      commandStore.socket.close();
      commandStore.clearCommandStore();
    }
  }, []);

  useEffect(() => {
    connect();
    return () => disconnect();
  }, [connect, disconnect]);

  return null;
};
